var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-form-login"},[_c('div',{staticClass:"layout-form-login-card"},[_c('CoverImage'),_c('h2',{staticClass:"institution-heading"},[_vm._v(_vm._s(_vm.heading))]),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }